import { apiFetch } from './client.js';
import type { IntegrationField } from './integrations.api.js';

/**
 * Settings → Treasury (DEV-139): each provider's accounts (client money,
 * shared, revenue) and GuruPay's commission transfer, stored as versions in
 * the settings store, apart from the provider's connection. Admin only.
 */

/** A Treasury field: the same shape the connection card uses, never a secret. */
export type TreasuryField = IntegrationField & { section: 'TREASURY_ACCOUNTS' | 'TREASURY_COMMISSION' };

export interface TreasuryProvider {
  provider: 'GURUPAY' | 'BANKERA' | 'MANUAL' | 'IBANQ';
  vendor: string;
  namespace: string;
  /** 0 while nothing is stored; a save names the version it replaces. */
  version: number;
  updatedAt: string | null;
  updatedBy: string | null;
  /** The provider's connection, which these accounts are verified and used through. */
  connection: { exists: boolean; active: boolean; configured: boolean; missingFields: string[] };
  fields: TreasuryField[];
}

export const TREASURY_KEY = ['treasury-settings'] as const;

export const treasuryApi = {
  list: (): Promise<TreasuryProvider[]> => apiFetch('/admin/settings/treasury'),
  /**
   * Store a new version: the latest one with these keys replaced. A different
   * client-money or revenue account, or switching to LIVE, needs a reason.
   */
  save: (provider: string, input: { expectedVersion: number; values: Record<string, unknown>; reason?: string }): Promise<TreasuryProvider & { changed: boolean }> =>
    apiFetch(`/admin/settings/treasury/${provider}`, { method: 'PUT', body: input }),
};
